export const invoiceResponseData = (response) => {
  const body = response?.data;
  if (body?.Success === false || body?.success === false) {
    throw new Error(body.Message || body.message || 'Unable to retrieve the document.');
  }
  return body?.Data ?? body?.data ?? body?.result ?? body;
};
